import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './shared/components.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslationRootModule } from './translation/translation.module';
import { SafePipe } from './pipes/safe.pipe';
import { HttpLoaderInterceptor } from './shared/components/http-loader.interceptor';
import { WifiConnectionLoaderInterceptor } from './shared/components/wifi-connection-loader/wifi-connection-loader.interceptor';
import { WifiConnectionLoaderComponent } from './shared/components/wifi-connection-loader/wifi-connection-loader.component';


@NgModule({
  declarations: [
    AppComponent,
    SafePipe
  ],
  imports: [
    BrowserModule,
    TranslationRootModule,
    HttpClientModule,
    AppRoutingModule,
    ComponentsModule,
    BrowserAnimationsModule,
    WifiConnectionLoaderComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpLoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: WifiConnectionLoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
